export default __webpack_public_path__ + "static/media/get_lucky.be2090a2.jpg";